module.exports = __webpack_public_path__ + "img/calendar-tick.8ceee78e.svg";